import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-btn-common',
	template: `<div class="btn btn-common {{className}}">
		<fa-icon *ngIf="icon" class="mr-2" [icon]="['fas', icon]"></fa-icon>
		<span>{{text}}</span>
	</div>`
})
export class BtnCommonComponent implements OnInit {

	@Input() text: string = 'Common';
	@Input() icon: string;
	@Input() className: string = '';

	constructor(
	) { }

	ngOnInit(): void {
	}

}
